/**
 * Semi-flexible input component thats currently
 * only being used for search
 */

import { h } from "preact";
import { InputProps } from "../types/inputTypes";

const Input = (props: InputProps) => {
  const {
    id,
    label,
    type,
    labelHidden,
    placeholder,
    onChange,
    inputStyle,
    formItemStyle,
  } = props;

  const labelStyle = labelHidden ? "srOnly" : "";

  return (
    <div class={formItemStyle}>
      <label class={labelStyle} for={id}>
        {label}
      </label>
      <input
        data-testid={id}
        id={id}
        type={type}
        class={inputStyle}
        placeholder={placeholder}
        onChange={(e) => onChange && onChange(e.currentTarget.value)}
      />
    </div>
  );
};

export default Input;
